import React, { FC } from 'react';
import { ITeaserRenderer } from '#components/lists/horizontal-scroll-list/HorizontalScrollList';
import { Teaser } from '#types/generated/graphql-types';
import TeaserGridContainer, {
  TeaserGridContainerProps,
} from '#components/lists/teaser-grid/TeaserGridContainer';
import TeaserListRenderer from '#components/lists/teaser-list-renderer/TeaserListRenderer';
import PosterTeaser from '#components/teasers/poster-teaser/PosterTeaser';

export type Props = {
  items: Teaser[];
  TeaserComponent?: React.FC<ITeaserRenderer>;
  renderItem?: (item: Teaser, index: number) => JSX.Element;
  teaserGridContainerProps?: TeaserGridContainerProps;
};

// @TODO: studios in search page results are not displayed properly
// a solution could be to use TeaserGridTeaserRenderer - in case we use this, make sure Series teaser hover works

const TeaserGrid: FC<Props> = ({
  items,
  renderItem,
  TeaserComponent = PosterTeaser,
  teaserGridContainerProps,
}) => {
  return (
    <TeaserGridContainer {...teaserGridContainerProps}>
      <TeaserListRenderer
        items={items}
        TeaserComponent={TeaserComponent}
        renderItem={renderItem}
      />
    </TeaserGridContainer>
  );
};

export default TeaserGrid;
